import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=36ecd012&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"
import style0 from "./Search.vue?vue&type=style&index=0&id=36ecd012&prod&scoped=true&lang=css"
import style1 from "./Search.vue?vue&type=style&index=1&id=36ecd012&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ecd012",
  null
  
)

export default component.exports